import React, { ReactNode } from 'react';
import { CheckboxField } from '../CheckboxField';

export interface Item<T> {
  label: ReactNode | string;
  value: T;
}

type checkboxValueType = number | string;

interface CheckboxGroupProps<T> {
  options: Array<Item<T>>;
  value: T[];
  name: string;
  onChange: (val: any) => void;
}

export const CheckboxGroup = <T extends checkboxValueType>(props: CheckboxGroupProps<T>) => {
  const { options } = props;

  const onSelect = (value: T) => () => {
    if (props.value.includes(value)) {
      props.onChange(props.value.filter(val => val !== value));
    }
    else {
      props.onChange([ ...props.value, value ]);
    }
  };

  const getIsChecked = (value: T) => {
    return props.value.includes(value);
  };

  return (
    <>
      {options.map(item => (
        <CheckboxField
          key={item.value}
          onClick={onSelect(item.value)}
          label={item.label}
          checked={getIsChecked(item.value)}
        />
      ))}
    </>
  );
};

export default CheckboxGroup;
